export const TOGGLE_NOTIFICATION_MODAL = 'toggleNotificationModal';
